import { Input, InputMask } from '@77sol-ui/atoms'
import { SelectGraceDays } from '../../components/ui/SelectGraceDays'
import { useCreateFinancingPerValueFormContext } from '../../hooks/useCreateFinancingPerValueForm'
import { MaskedMonetaryInput } from 'components/Controllers/MaskedMonetaryInput'
import * as S from './styles'

export function NaturalPerson() {
  const {
    register,
    control,
    formState: { errors },
    getValues,
  } = useCreateFinancingPerValueFormContext()

  return (
    <section>
      <Input
        label="Nome do Solicitante"
        placeholder="Digite o nome completo"
        type="text"
        error={errors.client_name?.message}
        {...register('client_name')}
      />
      <S.InputGroup>
        <InputMask.Masked
          label="Data de Nascimento"
          mask="99/99/9999"
          placeholder="DD/MM/AAAA"
          type="text"
          error={errors.client_birth_date?.message}
          {...register('client_birth_date')}
          defaultValue={getValues('client_birth_date') as string}
        />
        <InputMask.Masked
          label="CPF"
          placeholder="Digite o CPF"
          mask="999.999.999-99"
          type="text"
          error={errors.client_document?.message}
          {...register('client_document')}
          defaultValue={getValues('client_document')}
        />
      </S.InputGroup>
      <S.InputGroup>
        <InputMask.Masked
          label="Celular"
          mask="(99) 99999-9999"
          placeholder="Digite o Celular"
          type="text"
          error={errors.client_phone?.message}
          {...register('client_phone')}
          defaultValue={getValues('client_phone')}
        />
        <InputMask.Masked
          label="CEP da instalação"
          placeholder="Digite o CEP"
          mask="99999-999"
          type="text"
          error={errors.client_cep?.message}
          {...register('client_cep')}
          defaultValue={getValues('client_cep')}
        />
      </S.InputGroup>
      <S.InputGroup>
        <MaskedMonetaryInput
          label="Renda Mensal"
          placeholder="R$ 0,00"
          error={errors.client_income?.message}
          control={control}
          name="client_income"
        />
        <SelectGraceDays
          control={control}
          label="Dias de Carência"
          placeholder="Selecione os dias de Carência"
          name="grace_days"
          error={errors.grace_days?.message}
        />
      </S.InputGroup>
    </section>
  )
}
